import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  typeList: [],
};

export default function feedback(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 获取意见反馈字典
    case ACTION_TYPES.GET_FEEDBACK_DICT:
      result.typeList = payload;
      break;
    default:
      result = state;
  }
  return result;
}
